"use client";
import * as React from "react";
import { useContext } from "react";
import UserContext from "@/context/userContext";
import Copyright from "@/components/Copyright";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import TopNav from "@/components/TopNav";
import MainBody from "@/components/MainBody";
import { Stack } from "@mui/material";
import { GlobalStyles } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export default function Home() {
  const { user, setUser } = useContext(UserContext);
  const theme = useTheme();

  return (
    <>
      <GlobalStyles
        styles={{
          html: {
            backgoundColor: theme.palette.secondary.dark,
          },
          body: {
            backgroundColor: theme.palette.secondary.dark,
          },
        }}
      />

      <Container
        component="main"
        maxWidth="xl"
        sx={{
          backgroundColor: theme.palette.secondary.dark,
          minHeight: "100vh", // Ensure the container takes the full height
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between", // Ensure content is spaced correctly
          padding: 0, // Remove default padding
        }}
      >
        <Box
          sx={{
            marginTop: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            flexGrow: 1, // Ensure the main body takes up the remaining space
          }}
        >
          <TopNav />
          <MainBody />
        </Box>
        <Copyright sx={{ mt: 8, mb: 4 }} />
      </Container>
    </>
  );
}
